import {showMenu, hideMenu} from '../../menu/actions';

export const CLEAR = 'CART_CLEAR';
export const ADD = 'CART_ADD';
export const REMOVE = 'CART_REMOVE';
export const SET_COUNT = 'CART_SET_COUNT';
export const LOCK = 'CART_LOCK';
export const UNLOCK = 'CART_UNLOCK';

export const SET_INFO = 'CART_SET_INFO';
export const SET_DELIVERY_METHOD = 'CART_SET_DELIVERY_METHOD';
export const SET_PAYMENT_METHOD = 'CART_SET_PAYMENT_METHOD';

export function clearCart(itemType) {
    return {
        type: CLEAR,
        itemType,
    };
}

export function addToCart(payload) {
    return dispatch => {
        dispatch(showMenu([0, 0], 'drawer'));
        setTimeout(() => dispatch({
            type: ADD,
            payload,
        }), 600);
        setTimeout(() => dispatch(hideMenu('drawer')), 1000);
    };
}

export function removeFromCart(item) {
    return {
        type: REMOVE,
        item,
    };
}

export function setCount(item, value) {
    return {
        type: SET_COUNT,
        item,
        value,
    };
}

export function lock() {
    return {
        type: LOCK,
    };
}

export function unlock() {
    return {
        type: UNLOCK,
    };
}

export function setInfo(payload) {
    return {
        type: SET_INFO,
        payload,
    };
}

export function setDeliveryMethod(payload) {
    return {
        type: SET_DELIVERY_METHOD,
        payload,
    };
}

export function setPaymentMethod(payload) {
    return {
        type: SET_PAYMENT_METHOD,
        payload,
    };
}
